import type Highcharts from "highcharts";

// Preview builder: synthesizes deterministic mock Highcharts options for the radar
// configurator's live preview (no real pipeline call). Extracted verbatim from index.tsx.

export interface MockSeriesConfig { name: string; color: string; fill: boolean }

export function buildMockRadarOptions(
  vertexLabels: string[],
  series: MockSeriesConfig[],
  showLegend: boolean,
): Highcharts.Options {
  const n = vertexLabels.length;
  const mockSeries = series.map((s, i) => ({
    type: s.fill ? ("area" as const) : ("line" as const),
    name: s.name,
    data: Array.from({ length: n }, (_, j) => 15 + ((i * 19 + j * 13 + i * j * 3 + 7) % 70)),
    pointPlacement: "on" as const,
    color: s.color,
    ...(s.fill && { fillOpacity: 0.15 }),
  }));

  return {
    chart: {
      polar: true,
      type: "line",
      animation: false,
      style: { fontFamily: "inherit" },
    },
    title: { text: undefined },
    pane: { size: "80%" },
    xAxis: {
      categories: vertexLabels,
      tickmarkPlacement: "on",
      lineWidth: 0,
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      gridLineInterpolation: "polygon",
      lineWidth: 0,
      min: 0,
      max: 100,
      tickInterval: 25,
      labels: { enabled: false },
    },
    legend: {
      enabled: showLegend,
      align: "center",
      verticalAlign: "bottom",
    },
    tooltip: { shared: true },
    plotOptions: { series: { animation: false } },
    series: mockSeries,
    credits: { enabled: false },
    exporting: { enabled: false },
  };
}
